import httpService from "./httpService";
import { UserAccessLevel } from "V2.0/models/UserProfile";

export { updateUserAccessLevelPermissions };

function updateUserAccessLevelPermissions(
  userId: string,
  payload: UpdateUserRoleAndPermissionsPayload,
) {
  return httpService.patch(
    `/profile/editWhitelabelUserAccessLevel/${userId}`,
    payload,
  );
}

export interface WhitelabelViewerRolePayload {
  userAccessLevel: typeof UserAccessLevel.WHITELABELVIEWER;
}

export interface WhitelabelOperatorRolePayload {
  userAccessLevel: typeof UserAccessLevel.WHITELABELOPERATOR
  applicationSectionsVisible: [];
  assistantSectionsVisible: [];
}

export interface WhitelabelUserRolePayload {
  userAccessLEvel: typeof UserAccessLevel.WHITELABELUSER;
}

export type UpdateUserRoleAndPermissionsPayload =
  | WhitelabelOperatorRolePayload
  | WhitelabelUserRolePayload
  | WhitelabelViewerRolePayload;
